import type { SVGProps } from "react";
export default function SvgListCheck(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-list-check-icon lucide-list-check"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M16 5H3" />
			<path d="M16 12H3" />
			<path d="M11 19H3" />
			<path d="m15 18 2 2 4-4" />
		</svg>
	);
}
